import {
  IconUsers,
  IconHeart,
  IconPill,
  IconUsersGroup,
  IconHome,
  IconClipboardHeart,
} from '@tabler/icons-react';
import type { TherapyType } from './types';

/** Order matches common "what are you looking for" list. */
export const THERAPY_TYPE_OPTIONS: {
  value: TherapyType;
  label: string;
  icon: React.ReactNode;
}[] = [
  { value: 'individual', label: 'Individual therapy', icon: <IconUsers size={28} /> },
  { value: 'couples', label: 'Couples therapy', icon: <IconHeart size={28} /> },
  { value: 'family', label: 'Family therapy', icon: <IconHome size={28} /> },
  { value: 'group', label: 'Group therapy', icon: <IconUsersGroup size={28} /> },
  { value: 'iop', label: 'Intensive Outpatient Program (IOP)', icon: <IconClipboardHeart size={28} /> },
  { value: 'medication', label: 'Medication management', icon: <IconPill size={28} /> },
];
